import './index.less'
import { isiOS } from '@utils/index.js'
import { getPointAccount, } from "@utils/api.js"


export default class MembershipBenefits {
  constructor({ el, }) {
    this.DOM = document.querySelector(el)
    this.el = el

    // 跳会员主页按钮
    this.benefitBtn = document.querySelector('[data-membership-benefit-button]')
    if (this.benefitBtn) {
      this.initPoints()
    }

    if (this.DOM) {
      this.initSwiper()

      const debounceResizeHandler = debounce(() => this.initSwiper(), 100);
      window.addEventListener('resize', debounceResizeHandler)

      this.observe()
    }
  }
  async initPoints() {
    this.benefitBtn.onclick = (e) => {
      const target = e.target.tagName === 'SPAN' ? e.target.parentElement : e.target
      const link = target.dataset.link || `${window.pageInfo.membership_url}/index?cr=${window.pageInfo.cr}`
      // 因为苹果的安全机制拦截了，所以不能打开新的标签页
      isiOS() ? (window.location.href = link) : window.open(link, '_blank')
    }

    // 表示已登录
    if (window.pageInfo.customerInfo.id) {
      const pointsBtn = document.querySelector('[data-membership-benefit-points]')

      //需要调接口
      try {
        const data = await getPointAccount()
        pointsBtn.innerHTML = data?.data?.balancePoint || 0
      } catch (err) {
        pointsBtn.innerHTML = 0
      }
    }
  }
  initSwiper() {
    this.swiper?.destroy()
    this.swiper = null

    this.swiper = new Swiper(this.el, {
      slidesPerView: this.isMobile() ? 'auto' : 3,
      spaceBetween: 18,
      initialSlide: 0,
      slidesOffsetBefore: 20,
      slidesOffsetAfter: 20,
      navigation: {
        nextEl: '.swiper-membership-pc-button-next',
        prevEl: '.swiper-membership-pc-button-prev',
      },
      scrollbar: {
        el: ".swiper-scrollbar",
        hide: false,
      },
      breakpoints: {
        1024: {  // 当屏幕宽度大于等于1024
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
        }
      }
    })
  }
  isMobile() {
    const clientWidth = document.documentElement.clientWidth || document.body.clientWidth
    return clientWidth < 1024
  }

  observe() {
    const Observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active')
        }
      })
    }, {
      root: null,
      rootMargin: '0px',
      threshold: 0,
    })

    const parentDOM = this.DOM.parentElement.parentElement
    const targetDOMs = parentDOM.querySelectorAll('[data-animation-dom]')
    if (targetDOMs.length > 0) {
      targetDOMs.forEach(item => Observer.observe(item))
    }
  }
}
